import { render, staticRenderFns } from "./Page1.vue?vue&type=template&id=1eff2580&scoped=true&"
import script from "./Page1.vue?vue&type=script&lang=js&"
export * from "./Page1.vue?vue&type=script&lang=js&"
import style0 from "./Page1.vue?vue&type=style&index=0&id=1eff2580&prod&lang=css&"
import style1 from "./Page1.vue?vue&type=style&index=1&id=1eff2580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eff2580",
  null
  
)

export default component.exports